import breaksGeneralSection from "./breaksGeneralSection";
import breaksSiteSection from "./breaksSiteSection";
import breaksImageSection from "./breaksImageSection";
import breaksDesignSection from "./breaksDesignSection";
import breaksStepsSection from "./breaksStepsSection"
import breaksColorSection from "./breaksColorSection";
import breaksNavAndFilters from "./breaksNavAndFilters";
import breaksCampaignTargeting from "./breaksCampaignTargeting";
import breaksCampaignGating from "./breaksCampaignGating";
import breaksAccountInformation from "./breaksAccountInformation";
import breaksLandingScreen from './breaksLandingScreenSection';
import breaksPrizingInformation from "./breaksPrizingInformation";
import breakStepManagementSection from "./breakStepManagementSection";
import breaksContentCenterSection from "./breaksContentCenterSection";
import breaksHeroBannerSection from "./breaksHeroBannerSection";
import breaksFooterLinksSection from "./breaksFooterLinksSection";

const breakGeneralConfig = {
    sections: [
        breaksGeneralSection,
        breaksSiteSection,
        breaksImageSection,
        breaksDesignSection,
        breaksColorSection,
        breaksNavAndFilters,
        breaksCampaignTargeting,
        breaksCampaignGating,
        breaksAccountInformation,
        breaksPrizingInformation,
        breaksFooterLinksSection,
        breakStepManagementSection,
        breaksLandingScreen,
        // breaksContentCenterSection,
        breaksHeroBannerSection,
        breaksStepsSection
    ]
};

export default breakGeneralConfig;



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksConfig.js